import { useQueryClient } from "@tanstack/react-query";
import { getGetAnalysisQueryKey, useReturnAnalysisEditAccess } from "Infrastructure/ApiZfp/AnalyzerApi";
import { SharedAnalysisNotFoundErrorCode } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useContext } from "react";
import { toast } from "sonner";
import { AnalysisDetailContext } from "../AnalysisDetailContext";

export const useReturnEditAccess = () => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const queryClient = useQueryClient();

  const { mutate, isPending } = useReturnAnalysisEditAccess({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getGetAnalysisQueryKey(analysisId, versionId) });
        toast.success(t(Resources.AnalysisDetail.Sharing.Toast.Returned));
      },
      onError: (error) => {
        toast.error(
          error?.code === SharedAnalysisNotFoundErrorCode.nsure_agent_not_found
            ? t(Resources.AnalysisDetail.Sharing.Toast.ReturnNsureAccountMissing)
            : t(Resources.AnalysisDetail.Toast.ActionError),
        );
      },
    },
  });

  return {
    returnAccess: (options?: { onSettled?: () => void }) => mutate({ analysisId, versionId }, options),
    isReturning: isPending,
  };
};
